import script from "./PandoraCarrusel.vue?vue&type=script&setup=true&lang=js"
export * from "./PandoraCarrusel.vue?vue&type=script&setup=true&lang=js"

import "./PandoraCarrusel.vue?vue&type=style&index=0&id=73ddcf00&lang=css"

const __exports__ = script;

export default __exports__